"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var CPPHelper_1 = require("./CPPHelper");
var CPPVisibility_1 = require("./CPPVisibility");
var CPPCodeBlock_1 = require("./CPPCodeBlock");
var CPPWritableObject_1 = require("./CPPWritableObject");

var CPPClass = function () {
    function CPPClass(name) {
        _classCallCheck(this, CPPClass);

        this.name = name;
        this.constructorBody = [];
        this.constructorInitializerList = [];
        this.classIncludes = [];
        this.classExtends = [];
        this.methods = {};
        this.variables = {};
        this.name = name.replace(/[^A-Za-z_]/g, '');
        if (this.name.trim().length === 0) {
            this.name = 'GenericClass';
        }
    }

    _createClass(CPPClass, [{
        key: "getClassName",
        value: function getClassName() {
            return this.name;
        }
    }, {
        key: "setConstructor",
        value: function setConstructor(body, initializerList) {
            this.constructorBody = body;
            this.constructorInitializerList = initializerList;
        }
    }, {
        key: "getMethods",
        value: function getMethods() {
            return this.methods;
        }
    }, {
        key: "setMethod",
        value: function setMethod(fxn, visibility) {
            var virtual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            this.methods[fxn.getSignature()] = {
                virtual: virtual,
                visibility: visibility,
                functionDef: fxn
            };
        }
    }, {
        key: "getVariables",
        value: function getVariables() {
            return this.variables;
        }
    }, {
        key: "addVariable",
        value: function addVariable(variable, visibility) {
            this.variables[variable.getVariableName()] = {
                visibility: visibility,
                variable: variable
            };
        }
    }, {
        key: "getIncludes",
        value: function getIncludes() {
            return this.classIncludes;
        }
    }, {
        key: "addInclude",
        value: function addInclude(include) {
            this.classIncludes.push(include);
            return this;
        }
    }, {
        key: "removeInclude",
        value: function removeInclude(include) {
            var _this = this;

            this.classIncludes.forEach(function (element, index) {
                if (element === include) {
                    _this.classIncludes.splice(index, 1);
                    return true;
                }
            });
            return false;
        }
    }, {
        key: "getExtends",
        value: function getExtends() {
            return this.classExtends;
        }
    }, {
        key: "addExtends",
        value: function addExtends(classExtends) {
            this.classExtends.push(classExtends);
        }
    }, {
        key: "removeExtends",
        value: function removeExtends(classExtends) {
            var _this2 = this;

            this.classExtends.forEach(function (element, index) {
                if (element[0] === classExtends[0] && element[1] === classExtends[1]) {
                    _this2.classExtends.splice(index, 1);
                    return true;
                }
            });
            return false;
        }
    }, {
        key: "write",
        value: function write(formatter, indentCount) {
            var output = [];
            output.push(this.writeHeaderBlock(formatter, indentCount));
            for (var key in this.methods) {
                var fxn = this.methods[key];
                output.push(fxn.functionDef.write(formatter, indentCount));
            }
            return output.join('\n\n').trim();
        }
    }, {
        key: "writeClassSignature",
        value: function writeClassSignature() {
            var signature = "class " + this.name;
            if (this.classExtends.length > 0) {
                var classExtensions = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.classExtends[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var e = _step.value;

                        classExtensions.push(e[0] + " " + e[1]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                signature += " : " + classExtensions.join(', ');
            }
            return signature;
        }
    }, {
        key: "writeHeaderBlock",
        value: function writeHeaderBlock(formatter, indentCount) {
            var _definitionBodies, _instanceVariables;

            var definitionBodies = (_definitionBodies = {}, _defineProperty(_definitionBodies, CPPVisibility_1.default.Public, []), _defineProperty(_definitionBodies, CPPVisibility_1.default.Protected, []), _defineProperty(_definitionBodies, CPPVisibility_1.default.Private, []), _definitionBodies);
            var instanceVariables = (_instanceVariables = {}, _defineProperty(_instanceVariables, CPPVisibility_1.default.Public, []), _defineProperty(_instanceVariables, CPPVisibility_1.default.Protected, []), _defineProperty(_instanceVariables, CPPVisibility_1.default.Private, []), _instanceVariables);
            var classDefinitionBody = [];
            var hasInitializerList = this.constructorInitializerList.length > 0;
            var hasConstructorBody = this.constructorBody.length > 0;
            if (hasConstructorBody || hasInitializerList) {
                var constructorSig = this.getClassName() + "()";
                var initList = this.constructorInitializerList.join(",\n" + formatter.indentation.repeat(2));
                if (hasInitializerList) {
                    constructorSig = constructorSig + " : " + initList;
                }
                var _constructor = new CPPCodeBlock_1.default(constructorSig, this.constructorBody);
                definitionBodies[CPPVisibility_1.default.Public].push(_constructor);
            }
            for (var key in this.methods) {
                var _output = '';
                var fxn = this.methods[key];
                if (fxn.virtual) {
                    _output += 'virtual ';
                }
                _output += fxn.functionDef.getSignature(true);
                definitionBodies[fxn.visibility].push(new CPPWritableObject_1.default(_output));
            }
            for (var _key in this.variables) {
                var variable = this.variables[_key];
                instanceVariables[variable.visibility].push(variable.variable);
            }
            [CPPVisibility_1.default.Public, CPPVisibility_1.default.Protected, CPPVisibility_1.default.Private].forEach(function (visibility) {
                var fxnsExist = definitionBodies[visibility].length > 0;
                var varsExist = instanceVariables[visibility].length > 0;
                if (fxnsExist || varsExist) {
                    classDefinitionBody.push(CPPHelper_1.default.createEmptyLine());
                    classDefinitionBody.push(new CPPWritableObject_1.default(visibility + ":"));
                }
                if (fxnsExist) {
                    classDefinitionBody.push.apply(classDefinitionBody, _toConsumableArray(definitionBodies[visibility]));
                }
                if (varsExist) {
                    if (fxnsExist) {
                        classDefinitionBody.push(CPPHelper_1.default.createEmptyLine());
                    }
                    classDefinitionBody.push.apply(classDefinitionBody, _toConsumableArray(instanceVariables[visibility]));
                }
            });
            classDefinitionBody.shift();
            var blk = new CPPCodeBlock_1.default(this.writeClassSignature(), classDefinitionBody);
            var output = blk.write(formatter, indentCount);
            var indentRegex = /^[ \t]+(public|protected|private):$/gm;
            output = output.replace(indentRegex, '$1:');
            return output + ';';
        }
    }]);

    return CPPClass;
}();

exports.default = CPPClass;